const Constant = {
  domainList: {
    CHARGEMILES: "chargemiles",
    MOVEONEV: "moveonev",
    AMIK: "amikcharge",
    AMIKTECHNOLOGIES: "amiktechnologies",
    TECHVOLTNETWORK: "techvoltnetwork",
    AVVTECH: "avvtech",
    AYKACONTROLSYSTEMS: "acsenergy",
    ZEROFOOTPRINT: "zerofootprint",
    GBT: "bharatnp"
  },
};
export default Constant;
